import React, { useRef, useState, useEffect } from 'react';
import PdfViewer from './Pdfviewer';
import { motion, AnimatePresence } from 'framer-motion';
import { FiSun, FiMoon, FiX, FiMenu } from 'react-icons/fi';
import { FaChevronRight } from 'react-icons/fa';
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import './App.css';
 
const showToast = (title, icon = 'info') => {
  Swal.fire({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    icon,
    title,
  });
};
 
const placeholderSuggestions = [
  'Level_Prek 1-10...',
  'Level_K 51-60...',
  'Level_1X 1-10...',
  'Level_1Y 21-30...',
  'Level_2X 71-80...',
  'Level_2Y 101-110...',
  'Level_3X 1-10...',
  'Level_3Y 151-160...',
  'Level_4X 1-10...',
  'Level_4Y 151-160...',
  'Level_5X 1-10...',
  'Level_5Y 151-160...'
];
 
// Build levels structure - Using exact names from the image
const levels = {
  'Level_Prek': {
    booklets: []
  },
  'Level_K': {
    booklets: []
  },
  'Level_1X': {
    booklets: []
  },
  'Level_1Y': {
    booklets: []
  },
  'Level_2X': {
    booklets: []
  },
  'Level_2Y': {
    booklets: []
  },
  'Level_3X': {
    booklets: []
  },
  'Level_3Y': {
    booklets: []
  },
  'Level_4X': {
    booklets: []
  },
  'Level_4Y': {
    booklets: []
  },
  'Level_5X': {
    booklets: []
  },
  'Level_5Y': {
    booklets: []
  }
};
 
// Generate Pre-K booklets (PRE-K_1-10 to PRE-K_191-200)
for (let i = 1; i <= 191; i += 10) {
  const rangeEnd = Math.min(i + 9, 200);
  levels['Level_Prek'].booklets.push(`PRE-K_${i}-${rangeEnd}`);
}
 
// Generate K booklets (K_1-10 to K_191-200)
for (let i = 1; i <= 191; i += 10) {
  const rangeEnd = Math.min(i + 9, 200);
  levels['Level_K'].booklets.push(`K_${i}-${rangeEnd}`);
}
 
// Generate X booklets for all grades
for (let grade = 1; grade <= 5; grade++) {
  for (let i = 1; i <= 191; i += 10) {
    const rangeEnd = Math.min(i + 9, 200);
    levels[`Level_${grade}X`].booklets.push(`L${grade}X_${i}-${rangeEnd}`);
  }
}
 
// Generate Y booklets for all grades
for (let grade = 1; grade <= 5; grade++) {
  for (let i = 1; i <= 191; i += 10) {
    const rangeEnd = Math.min(i + 9, 200);
    levels[`Level_${grade}Y`].booklets.push(`L${grade}Y_${i}-${rangeEnd}`);
  }
}
 
const getUserName = () => "Student";
 
function Home({ onLogout }) {
  const [animatedPlaceholder, setAnimatedPlaceholder] = useState('');
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth > 1024);
  const [selectedLevel, setSelectedLevel] = useState('Level_Prek');
  const [selectedBooklet, setSelectedBooklet] = useState('PRE-K_1-10');
  const [expandedLevels, setExpandedLevels] = useState({ 'Level_Prek': true });
  const [darkMode, setDarkMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  
  const formatLevelParam = (param) => {
    if (!param) return null;
 
    const normalized = param
      .replace(/-/g, "_")   // convert hyphens to underscores
      .toLowerCase()        // case-insensitive compare
      .replace("level_", "Level_"); // enforce capital L and format
 
    const validLevels = Object.keys(levels); // from your levels object
 
    // Find exact match ignoring case
    const match = validLevels.find(
      (lvl) => lvl.toLowerCase() === normalized.toLowerCase()
    );
 
    return match || null;
  };
 
 
  const { levelParam } = useParams();
  const formattedLevel = formatLevelParam(levelParam);
  console.log(levelParam)
 
 
  useEffect(() => {
    if (formattedLevel) {
      setSelectedLevel(formattedLevel);
      setExpandedLevels({ [formattedLevel]: true });
      setSelectedBooklet(levels[formattedLevel].booklets[0]);
    } else {
      setExpandedLevels({ "Level_Prek": true });
    }
  }, [formattedLevel]);
 
 
 
 
  const bookletRef = useRef();
 
  const toggleSidebar = () => setSidebarVisible(prev => !prev);
 
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
 
  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prev) => (prev + 1) % placeholderSuggestions.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
 
  useEffect(() => {
    const current = placeholderSuggestions[placeholderIndex];
    let charIndex = 0;
    const typeInterval = setInterval(() => {
      setAnimatedPlaceholder(current.slice(0, charIndex));
      charIndex++;
      if (charIndex > current.length) clearInterval(typeInterval);
    }, 50);
    return () => clearInterval(typeInterval);
  }, [placeholderIndex]);
 
  useEffect(() => {
    requestAnimationFrame(() => {
      if (bookletRef.current) bookletRef.current.scrollTop = 0;
    });
  }, [selectedBooklet]);
 
  const currentLevel = levels[selectedLevel];
 
  // Build PDF source path - UPDATED for new level names
  let bookletSrc = '';
  if (selectedBooklet) {
    // Remove any existing .pdf extension and add it properly
    const cleanBooklet = selectedBooklet.replace('.pdf', '');
   
    if (selectedLevel === 'Level_Prek') {
      bookletSrc = `/pdfs/PRE-K/${cleanBooklet}.pdf`;
    } else if (selectedLevel === 'Level_K') {
      bookletSrc = `/pdfs/K/${cleanBooklet}.pdf`;
    } else {
      // For Level_1X, Level_1Y, etc., extract the grade and use Grade X folder structure
      const levelNumber = selectedLevel.replace('Level_', ''); // Remove "Level_" prefix
      const grade = levelNumber.charAt(0); // Get the number from 1X, 2Y, etc.
      const subfolder = levelNumber; // Use 1X, 1Y, etc. as subfolder
      bookletSrc = `/pdfs/Grade ${grade}/${subfolder}/${cleanBooklet}.pdf`;
    }
  }
 
  // Debug: log the PDF path
  useEffect(() => {
    console.log('Loading PDF:', bookletSrc);
  }, [bookletSrc]);
 
  // Dummy scroll handler (required by PdfViewer but not used)
  const handleScroll = (scrollTop) => {
    // No-op since we don't need scroll syncing
  };
 
  // const handleLogoutClick = () => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'You will be logged out.',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, logout',
  //     cancelButtonText: 'Cancel',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       localStorage.removeItem('isLoggedIn');
  //       localStorage.removeItem('userEmail');
  //       onLogout();
  //     }
  //   });
  // };
 
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode === 'true') {
      setDarkMode(true);
      document.body.classList.add('dark-mode');
    }
  }, []);
 
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === 'p' || e.key === 's')) {
        e.preventDefault();
        alert('This action is disabled.');
      }
    };
    window.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
 
  const handleSearch = (input) => {
    setSearchTerm(input);
    const normalizedInput = input
      .toLowerCase()
      .replace(/[_–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\bpre\s*k\b/gi, 'pre-k')
      .replace(/\bgrade\s*/gi, 'grade ')
      .replace(/\.{2,}/g, '')
      .trim();
 
    if (!normalizedInput) {
      setSearchResults([]);
      return;
    }
 
    const results = [];
    const added = new Set();
 
    // Search through all levels
    Object.entries(levels).forEach(([levelKey, content]) => {
      content.booklets.forEach((booklet) => {
        const display = `${levelKey} ${booklet}`.toLowerCase();
        const bookletDisplay = booklet.replace(/_/g, ' ').toLowerCase();
       
        if (display.includes(normalizedInput) || bookletDisplay.includes(normalizedInput)) {
          const key = `${levelKey}_${booklet}`;
          if (!added.has(key)) {
            results.push({ level: levelKey, booklet });
            added.add(key);
          }
        }
      });
    });
 
    setSearchResults(results);
  };
 
  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem('darkMode', newMode);
      if (newMode) document.body.classList.add('dark-mode');
      else document.body.classList.remove('dark-mode');
      return newMode;
    });
  };
 
  const userEmail = localStorage.getItem('userEmail');
  const userName = getUserName(userEmail);
 
  return (
    <div className={`app-container ${darkMode ? 'dark' : ''}`}>
      <div className={`sidebar ${sidebarVisible ? 'visible' : 'hidden'}`}>
        <div className="welcome-card">👋 Hello {userName}!</div>
        <div className="level-scroll-area">
          {Object.entries(levels)
            .filter(([level]) => (formattedLevel ? level === formattedLevel : true))
            .map(([level, content]) => {
              const isExpanded = expandedLevels[level];
 
              return (
                <div key={level}>
                  <button
                    className={`level-btn ${selectedLevel === level ? 'active' : ''}`}
                    onClick={() => {
                      const firstBooklet = content.booklets[0];
                      const newState = !isExpanded;
                      setSelectedLevel(level);
                      setSelectedBooklet(firstBooklet);
                      setExpandedLevels({ [level]: newState });
                      showToast(`${level} ${newState ? 'expanded' : 'collapsed'}`, 'info');
                    }}
                  >
                    {level}
                    <span className={`arrow ${isExpanded ? 'rotate' : ''}`}>
                      <FaChevronRight />
                    </span>
                  </button>
 
                  <AnimatePresence initial={false}>
                    {isExpanded && (
                      <motion.div
                        className="booklet-list"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        {content.booklets.map((booklet) => (
                          <button
                            key={booklet}
                            className={`booklet-btn ${selectedBooklet === booklet ? 'selected' : ''}`}
                            onClick={() => {
                              setSelectedLevel(level);
                              setSelectedBooklet(booklet);
                            }}
                          >
                            {booklet.replace(/_/g, ' ')}
                          </button>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
        </div>
        {/* <button className="logout-btn" onClick={handleLogoutClick}>Logout</button> */}
      </div>
      <AnimatePresence>
        {sidebarVisible && !isDesktop && (
          <motion.div
            className="sidebar-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={() => setSidebarVisible(false)}
          />
        )}
      </AnimatePresence>
      <div className="right-container">
        <div className="top-bar">
          <button className="burger-btn" onClick={toggleSidebar}>
            <FiMenu size={24} />
          </button>
          <div className="search-bar">
            <div className="search-container">
              <input
                type="text"
                className="search-input"
                placeholder=""
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {searchTerm === '' && (
                <div className="placeholder-wrapper">
                  <span className="fixed-text">Search</span>
                  <span key={placeholderIndex} className="animated-text">
                    {animatedPlaceholder}
                  </span>
                </div>
              )}
              {searchTerm !== '' && (
                <button className="clear-button" onClick={() => handleSearch('')}>
                  <FiX size={20} />
                </button>
              )}
            </div>
          </div>
          <div className="button-box">
            <label className="custom-toggle">
              <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
              <span className="slider">
                <FiSun className="icon sun" />
                <FiMoon className="icon moon" />
              </span>
            </label>
          </div>
        </div>
        {searchResults.length > 0 && (
          <div className="search-results">
            {searchResults.map((res, idx) => (
              <div
                key={idx}
                className="search-result-item"
                onClick={() => {
                  setSelectedLevel(res.level);
                  setSelectedBooklet(res.booklet);
                  setExpandedLevels({ [res.level]: true });
                  setSearchResults([]);
                  setSearchTerm('');
                }}
              >
                <span>{res.level}</span>
                <FaChevronRight style={{ margin: '0 6px', fontSize: '12px' }} />
                <span>{res.booklet.replace(/_/g, ' ')}</span>
              </div>
            ))}
          </div>
        )}
        <div className="viewer-container">
          <div className="pdf-box">
            <PdfViewer
              src={bookletSrc}
              label={selectedBooklet ? selectedBooklet.replace(/_/g, ' ') : ''}
              colorClass="blue-box"
              onScroll={handleScroll}
              scrollContainerRef={bookletRef}
              showSearch={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default Home;